import React from 'react';
import { string } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { DHTML } from '../../../components/DHTML/DHTML';
import analyticsEvents from '../../../actions/AnalyticsAction';

const IrisDHTML = ({ componentType, copyBlock, html }) => {
    const {
        featureFlags: { disableShowMore = true } = {},
        isNative = false,
        requestUrl = '',
        preferences: {
            plccBenefitsUrl = '/m/plcc-benefits',
            plccApplyClass = '.applyBtn',
            MarketingUrlChange: { fromUrl = '', toUrl = '', changeS7 = false } = {},
        } = {},
    } = useSelector(({ context = {} }) => context);

    const isplccBenefitPage = plccBenefitsUrl === requestUrl;

    const dispatch = useDispatch();
    const plccAnylyticstrigger = () => {
        const payloadParams = {
            name: 'PLCC_APPLY_NOW_LINK',
            plccBanner: 'static_rewards_apply',
        };
        /* istanbul ignore next */
        dispatch(analyticsEvents.plccApplyAnalytics(payloadParams));
    };

    const shouldRender = !isNative || (isNative && componentType !== 'seoblock');
    const shouldShowMore = disableShowMore ? !disableShowMore : !!copyBlock;
    let transformedHTML = '';

    if (html) {
        const imageUrl = `src="https:${fromUrl}`;
        const replaceUrl = `src="https:${toUrl}`;

        transformedHTML = !changeS7 ? html.split(imageUrl).join(replaceUrl) : html;
    }

    return (
        shouldRender && (
            <DHTML
                html={copyBlock || transformedHTML}
                showMore={shouldShowMore}
                automationId={copyBlock ? 'seo-block' : 'dhtml-content'}
                requestUrl={requestUrl}
                componentType={componentType}
                plccAnylyticstrigger={plccAnylyticstrigger}
                plccApplyClass={plccApplyClass}
                isplccBenefitPage={isplccBenefitPage}
            />
        )
    );
};

IrisDHTML.propTypes = {
    componentType: string,
    copyBlock: string,
    html: string,
};

IrisDHTML.defaultProps = {
    componentType: '',
    copyBlock: '',
    html: '',
};

export default IrisDHTML;
